var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5486 20.936C25.089 18.858 26 16.2854 26 13.5C26 6.59639 20.4035 1 13.5 1C6.59639 1 1 6.59639 1 13.5C1 20.4035 6.59639 26 13.5 26C17.122 26 20.3841 24.4596 22.6672 21.998C22.9802 21.6604 23.2744 21.3059 23.5486 20.936ZM22.8555 19.75C24.0521 17.9624 24.7499 15.8126 24.7499 13.5C24.7499 7.2868 19.7132 2.24997 13.4999 2.24997C7.2868 2.24997 2.24997 7.2868 2.24997 13.5C2.24997 15.8128 2.94777 17.9624 4.14446 19.75C5.65416 17.4946 7.95782 15.8155 10.6556 15.1127C9.35303 14.2101 8.49997 12.7047 8.49997 10.9999C8.49997 8.23853 10.7386 5.99989 13.5 5.99989C16.2614 5.99989 18.5 8.23853 18.5 10.9999C18.5 12.7046 17.6468 14.2101 16.3444 15.1126C19.042 15.8155 21.3458 17.4945 22.8555 19.75ZM22.0504 20.8115C20.2961 17.9267 17.1232 15.9999 13.5001 15.9999C9.87698 15.9999 6.70389 17.9267 4.94963 20.8116C7.01296 23.2222 10.078 24.75 13.5 24.75C16.922 24.75 19.987 23.2221 22.0504 20.8115ZM13.5 14.75C15.5711 14.75 17.2501 13.0712 17.2501 10.9999C17.2501 8.92881 15.5712 7.24987 13.5 7.24987C11.4288 7.24987 9.74995 8.92894 9.74995 11.0001C9.74995 13.0712 11.4289 14.75 13.5 14.75Z",
    fill: "#2B2526",
    stroke: "#2B2526",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.9a2fb25b5e24d9327bf95f1e222d5f5f.svg";
export { ForwardRef as ReactComponent };